var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "style-sub-item",
    {
      staticClass: "c-bi-dashboard-text-style",
      staticStyle: { "margin-top": "12px", padding: "12px" },
      attrs: { title: "文本样式配置" },
    },
    [
      _c(
        "div",
        { staticClass: "chart-form-item-warp" },
        [
          _c("span", { staticClass: "jz-chart-title-label" }, [
            _vm._v("\n            字体颜色\n        "),
          ]),
          _vm._v(" "),
          _c("el-color-picker", {
            model: {
              value: _vm.config.color,
              callback: function ($$v) {
                _vm.$set(_vm.config, "color", $$v)
              },
              expression: "config.color",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "chart-form-item-warp" },
        [
          _c("span", { staticClass: "jz-chart-title-label" }, [
            _vm._v("\n            字体大小\n        "),
          ]),
          _vm._v(" "),
          _c("el-input-number", {
            attrs: { min: 12, max: 60, step: 1, "controls-position": "right" },
            model: {
              value: _vm.config.fontSize,
              callback: function ($$v) {
                _vm.$set(_vm.config, "fontSize", $$v)
              },
              expression: "config.fontSize",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "chart-form-item-warp" },
        [
          _c("span", { staticClass: "jz-chart-title-label" }, [
            _vm._v("\n            加粗\n        "),
          ]),
          _vm._v(" "),
          _c("el-switch", {
            model: {
              value: _vm.config.isBold,
              callback: function ($$v) {
                _vm.$set(_vm.config, "isBold", $$v)
              },
              expression: "config.isBold",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "chart-form-item-warp" },
        [
          _c("span", { staticClass: "jz-chart-title-label" }, [
            _vm._v("\n            斜体\n        "),
          ]),
          _vm._v(" "),
          _c("el-switch", {
            model: {
              value: _vm.config.isItalic,
              callback: function ($$v) {
                _vm.$set(_vm.config, "isItalic", $$v)
              },
              expression: "config.isItalic",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }